import {
    QueryBuilderQuery,
    QueryBuilderQueryConditionTypeEnum,
    QueryBuilderReducerActionTypeEnum,
    QueryBuilderReducerDispatch,
    ThemeMixin
} from "../../../index";
import React, {FunctionComponent, useCallback} from "react";
import {Box, BoxProps, Chip, Theme, useMediaQuery, useTheme} from "@mui/material";
import {AddOutlined} from "@mui/icons-material";
import QueryBuilderSavedTemplatesSelect from "../saved-templates-select";
import {QueryBuilderProps} from "../../index";


export interface QueryBuilderFooterProps {
    dispatch: QueryBuilderReducerDispatch;
    name: QueryBuilderProps['name'];
    hideConditions: QueryBuilderProps['hideConditions'];
}

const QueryBuilderFooter: FunctionComponent<QueryBuilderFooterProps> = ({
                                                                            dispatch,
                                                                            name,
                                                                            hideConditions,
                                                                        }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    /**
     * Adds a new condition to the query.
     */
    const addCondition = useCallback<Required<BoxProps>['onClick']>(() => {
        dispatch({
            type: QueryBuilderReducerActionTypeEnum.AddCondition,
            payload: {
                condition: QueryBuilderQueryConditionTypeEnum.AND,
            },
        })
    }, [dispatch])

    /**
     * Sets the query in the reducer.
     */
    const setQuery = useCallback((query: QueryBuilderQuery) => {
        dispatch({
            type: QueryBuilderReducerActionTypeEnum.SetQuery,
            payload: {
                query: query,
            },
        })
    }, [dispatch])

    /**
     * The sx style mixin for the condition's box.
     */
    const boxMixin = useCallback<ThemeMixin<Theme>>((theme) => {
        return {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginInlineStart: 4,
            position: 'relative',
            ...(!hideConditions && {
                '&:before': {
                    position: 'absolute',
                    content: '""',
                    top: -16,
                    left: -20,
                    width: 20,
                    height: `calc(100% - 6px)`,
                    borderLeft: `1px dashed ${theme.palette.primary.main}`,
                    borderBottom: `1px dashed ${theme.palette.primary.main}`,
                },
            }),

        };
    }, [hideConditions])

    return (
        <>
            <Box sx={boxMixin}>
                {
                    !hideConditions &&
                    <Chip
                        icon={<AddOutlined color={'primary'}/>}
                        label={"Add Filter Condition"}
                        onClick={addCondition}
                        sx={(theme) => ({
                            border: `1px dashed ${theme.palette.primary.main}`,
                            background: 'transparent',
                        })}
                    />
                }
                {
                    name && !isMobile &&
                    <QueryBuilderSavedTemplatesSelect
                        name={name}
                        onSelect={setQuery}
                    />
                }
            </Box>
            {
                name && isMobile &&
                <QueryBuilderSavedTemplatesSelect
                    name={name}
                    onSelect={setQuery}
                />
            }
        </>
    );
}

export default QueryBuilderFooter;
